import React from 'react';

const ErrorPage = ({ statusCode }: { statusCode?: number }) => {
  return (
    <div
      className="flex h-screen flex-col items-center justify-center px-6 py-50 text-white max-xl:h-full"
      data-status-code={statusCode}
    >
      <h2 className="mb-10 text-center text-[52px] font-bold max-xl:text-[32px]/[32px]">
        Sorry, we couldn&apos;t find the page you&apos;re looking for.
      </h2>
      <span className="text-center text-[22px]">
        Please make sure you typed in the right URL. You can{' '}
        <a target="_blank" className={'text-blue-600'} href="mailto:message@parsec.com.cn" rel="noreferrer">
          contact
        </a>{' '}
        Parsec to discuss any problems you&apos;re experiencing.
      </span>
    </div>
  );
};

export default ErrorPage;
